export const GET_APPOINTMENTS_REQUEST = "GET_APPOINTMENTS_REQUEST";
export const GET_APPOINTMENTS_SUCCESS = "GET_APPOINTMENTS_SUCCESS";
export const GET_APPOINTMENTS_FAILURE = "GET_APPOINTMENTS_FAILURE";

export const CLEAR_APPOINTMENTS_DATA = 'CLEAR_APPOINTMENTS_DATA';

export const GET_CLINIC_UPCOMING_APPOINTMENTS_REQUEST =
    "GET_CLINIC_UPCOMING_APPOINTMENTS_REQUEST";
export const GET_CLINIC_UPCOMING_APPOINTMENTS_SUCCESS =
    "GET_CLINIC_UPCOMING_APPOINTMENTS_SUCCESS";
export const GET_CLINIC_UPCOMING_APPOINTMENTS_FAILURE =
    "GET_CLINIC_UPCOMING_APPOINTMENTS_FAILURE";

export const GET_REQUESTED_APPOINTMENTS_REQUEST =
    "GET_REQUESTED_APPOINTMENTS_REQUEST";
export const GET_REQUESTED_APPOINTMENTS_SUCCESS =
    "GET_REQUESTED_APPOINTMENTS_SUCCESS";
export const GET_REQUESTED_APPOINTMENTS_FAILURE =
    "GET_REQUESTED_APPOINTMENTS_FAILURE";

export const GET_CLINIC_REQUESTED_APPOINTMENTS_REQUEST =
    "GET_CLINIC_REQUESTED_APPOINTMENTS_REQUEST";
export const GET_CLINIC_REQUESTED_APPOINTMENTS_SUCCESS =
    "GET_CLINIC_REQUESTED_APPOINTMENTS_SUCCESS";
export const GET_CLINIC_REQUESTED_APPOINTMENTS_FAILURE =
    "GET_CLINIC_REQUESTED_APPOINTMENTS_FAILURE";

export const POST_SEARCH_DOCTOR_APPOINTMENT_REQUEST =
    "POST_SEARCH_DOCTOR_APPOINTMENT_REQUEST";
export const POST_SEARCH_DOCTOR_APPOINTMENT_SUCCESS =
    "POST_SEARCH_DOCTOR_APPOINTMENT_SUCCESS";
export const POST_SEARCH_DOCTOR_APPOINTMENT_FAILURE =
    "POST_SEARCH_DOCTOR_APPOINTMENT_FAILURE";

export const GET_USER_TYPE_APPOINTMENT_REQUEST =
    "GET_USER_TYPE_APPOINTMENT_REQUEST";
export const GET_USER_TYPE_APPOINTMENT_SUCCESS =
    "GET_USER_TYPE_APPOINTMENT_SUCCESS";
export const GET_USER_TYPE_APPOINTMENT_FAILURE =
    "GET_USER_TYPE_APPOINTMENT_FAILURE";

export const POST_ALL_AVAILABILITY_REQUEST = "POST_ALL_AVAILABILITY_REQUEST";
export const POST_ALL_AVAILABILITY_SUCCESS = "POST_ALL_AVAILABILITY_SUCCESS";
export const POST_ALL_AVAILABILITY_FAILURE = "POST_ALL_AVAILABILITY_FAILURE";

export const GET_SELECTED_USER_DETAILS_REQUEST =
    "GET_SELECTED_USER_DETAILS_REQUEST";
export const GET_SELECTED_USER_DETAILS_SUCCESS =
    "GET_SELECTED_USER_DETAILS_SUCCESS";
export const GET_SELECTED_USER_DETAILS_FAILURE =
    "GET_SELECTED_USER_DETAILS_FAILURE";

export const POST_BOOK_OFFLINE_APPOINTMENT_REQUEST =
    "POST_BOOK_OFFLINE_APPOINTMENT_REQUEST";
export const POST_BOOK_OFFLINE_APPOINTMENT_SUCCESS =
    "POST_BOOK_OFFLINE_APPOINTMENT_SUCCESS";
export const POST_BOOK_OFFLINE_APPOINTMENT_FAILURE =
    "POST_BOOK_OFFLINE_APPOINTMENT_FAILURE";

export const POST_UPLOAD_DOCUMENT_REQUEST = "POST_UPLOAD_DOCUMENT_REQUEST";
export const POST_UPLOAD_DOCUMENT_SUCCESS = "POST_UPLOAD_DOCUMENT_SUCCESS";
export const POST_UPLOAD_DOCUMENT_FAILURE = "POST_UPLOAD_DOCUMENT_FAILURE";

export const POST_APPOINTMENT_STATUS_REQUEST =
    "POST_APPOINTMENT_STATUS_REQUEST";
export const POST_APPOINTMENT_STATUS_SUCCESS =
    "POST_APPOINTMENT_STATUS_SUCCESS";
export const POST_APPOINTMENT_STATUS_FAILURE =
    "POST_APPOINTMENT_STATUS_FAILURE";

export const POST_BOOKED_APPOINTMENT_REQUEST =
    "POST_BOOKED_APPOINTMENT_REQUEST";
export const POST_BOOKED_APPOINTMENT_SUCCESS =
    "POST_BOOKED_APPOINTMENT_SUCCESS";
export const POST_BOOKED_APPOINTMENT_FAILURE =
    "POST_BOOKED_APPOINTMENT_FAILURE";

export const POST_CANCEL_APPOINTMENT_REQUEST =
    "POST_CANCEL_APPOINTMENT_REQUEST";
export const POST_CANCEL_APPOINTMENT_SUCCESS =
    "POST_CANCEL_APPOINTMENT_SUCCESS";
export const POST_CANCEL_APPOINTMENT_FAILURE =
    "POST_CANCEL_APPOINTMENT_FAILURE";

export const GET_QUESTION_REQUEST = "GET_QUESTION_REQUEST";
export const GET_QUESTION_SUCCESS = "GET_QUESTION_SUCCESS";
export const GET_QUESTION_FAILURE = "GET_QUESTION_FAILURE";

export const GET_ANSWERS_REQUEST = "GET_ANSWERS_REQUEST";
export const GET_ANSWERS_SUCCESS = "GET_ANSWERS_SUCCESS";
export const GET_ANSWERS_FAILURE = "GET_ANSWERS_FAILURE";

export const GET_PATIENT_BY_ID_REQUEST = "GET_PATIENT_BY_ID_REQUEST";
export const GET_PATIENT_BY_ID_SUCCESS = "GET_PATIENT_BY_ID_SUCCESS";
export const GET_PATIENT_BY_ID_FAILURE = "GET_PATIENT_BY_ID_FAILURE";

export const POST_SAVE_PATIENT_DETAIL_REQUEST =
    "POST_SAVE_PATIENT_DETAIL_REQUEST";
export const POST_SAVE_PATIENT_DETAIL_SUCCESS =
    "POST_SAVE_PATIENT_DETAIL_SUCCESS";
export const POST_SAVE_PATIENT_DETAIL_FAILURE =
    "POST_SAVE_PATIENT_DETAIL_FAILURE";

export const GET_BOOKED_CHAT_DETAILS_REQUEST =
    "GET_BOOKED_CHAT_DETAILS_REQUEST";
export const GET_BOOKED_CHAT_DETAILS_SUCCESS =
    "GET_BOOKED_CHAT_DETAILS_SUCCESS";
export const GET_BOOKED_CHAT_DETAILS_FAILURE =
    "GET_BOOKED_CHAT_DETAILS_FAILURE";

export const POST_FETCH_NEXT_APPOINTMENTS_REQUEST = "POST_FETCH_NEXT_APPOINTMENTS_REQUEST";
export const POST_FETCH_NEXT_APPOINTMENTS_SUCCESS = "POST_FETCH_NEXT_APPOINTMENTS_SUCCESS";
export const POST_FETCH_NEXT_APPOINTMENTS_FAILURE = "POST_FETCH_NEXT_APPOINTMENTS_FAILURE";

export const POST_GET_EMERGENCY_CALL_BY_PATIENT_REQUEST = "POST_GET_EMERGENCY_CALL_BY_PATIENT_REQUEST";
export const POST_GET_EMERGENCY_CALL_BY_PATIENT_SUCCESS = "POST_GET_EMERGENCY_CALL_BY_PATIENT_SUCCESS";
export const POST_GET_EMERGENCY_CALL_BY_PATIENT_FAILURE = "POST_GET_EMERGENCY_CALL_BY_PATIENT_FAILURE";

export const POST_GET_CHAT_APPOINTMENT_BY_PATIENT_REQUEST = "POST_GET_CHAT_APPOINTMENT_BY_PATIENT_REQUEST";
export const POST_GET_CHAT_APPOINTMENT_BY_PATIENT_SUCCESS = "POST_GET_CHAT_APPOINTMENT_BY_PATIENT_SUCCESS";
export const POST_GET_CHAT_APPOINTMENT_BY_PATIENT_FAILURE = "POST_GET_CHAT_APPOINTMENT_BY_PATIENT_FAILURE";

const actionTypePatient = {
    GET_APPOINTMENTS_REQUEST,
    GET_APPOINTMENTS_SUCCESS,
    GET_APPOINTMENTS_FAILURE,

    CLEAR_APPOINTMENTS_DATA,

    GET_CLINIC_UPCOMING_APPOINTMENTS_REQUEST,
    GET_CLINIC_UPCOMING_APPOINTMENTS_SUCCESS,
    GET_CLINIC_UPCOMING_APPOINTMENTS_FAILURE,

    GET_REQUESTED_APPOINTMENTS_REQUEST,
    GET_REQUESTED_APPOINTMENTS_SUCCESS,
    GET_REQUESTED_APPOINTMENTS_FAILURE,

    GET_CLINIC_REQUESTED_APPOINTMENTS_REQUEST,
    GET_CLINIC_REQUESTED_APPOINTMENTS_SUCCESS,
    GET_CLINIC_REQUESTED_APPOINTMENTS_FAILURE,

    POST_SEARCH_DOCTOR_APPOINTMENT_REQUEST,
    POST_SEARCH_DOCTOR_APPOINTMENT_SUCCESS,
    POST_SEARCH_DOCTOR_APPOINTMENT_FAILURE,

    GET_USER_TYPE_APPOINTMENT_REQUEST,
    GET_USER_TYPE_APPOINTMENT_SUCCESS,
    GET_USER_TYPE_APPOINTMENT_FAILURE,

    POST_ALL_AVAILABILITY_REQUEST,
    POST_ALL_AVAILABILITY_SUCCESS,
    POST_ALL_AVAILABILITY_FAILURE,

    GET_SELECTED_USER_DETAILS_REQUEST,
    GET_SELECTED_USER_DETAILS_SUCCESS,
    GET_SELECTED_USER_DETAILS_FAILURE,

    POST_BOOK_OFFLINE_APPOINTMENT_REQUEST,
    POST_BOOK_OFFLINE_APPOINTMENT_SUCCESS,
    POST_BOOK_OFFLINE_APPOINTMENT_FAILURE,

    POST_UPLOAD_DOCUMENT_REQUEST,
    POST_UPLOAD_DOCUMENT_SUCCESS,
    POST_UPLOAD_DOCUMENT_FAILURE,

    POST_APPOINTMENT_STATUS_REQUEST,
    POST_APPOINTMENT_STATUS_SUCCESS,
    POST_APPOINTMENT_STATUS_FAILURE,

    POST_BOOKED_APPOINTMENT_REQUEST,
    POST_BOOKED_APPOINTMENT_SUCCESS,
    POST_BOOKED_APPOINTMENT_FAILURE,

    POST_CANCEL_APPOINTMENT_REQUEST,
    POST_CANCEL_APPOINTMENT_SUCCESS,
    POST_CANCEL_APPOINTMENT_FAILURE,

    GET_QUESTION_REQUEST,
    GET_QUESTION_SUCCESS,
    GET_QUESTION_FAILURE,

    GET_ANSWERS_REQUEST,
    GET_ANSWERS_SUCCESS,
    GET_ANSWERS_FAILURE,

    GET_PATIENT_BY_ID_REQUEST,
    GET_PATIENT_BY_ID_SUCCESS,
    GET_PATIENT_BY_ID_FAILURE,

    POST_SAVE_PATIENT_DETAIL_REQUEST,
    POST_SAVE_PATIENT_DETAIL_SUCCESS,
    POST_SAVE_PATIENT_DETAIL_FAILURE,

    GET_BOOKED_CHAT_DETAILS_REQUEST,
    GET_BOOKED_CHAT_DETAILS_SUCCESS,
    GET_BOOKED_CHAT_DETAILS_FAILURE,

    POST_FETCH_NEXT_APPOINTMENTS_REQUEST,
    POST_FETCH_NEXT_APPOINTMENTS_SUCCESS,
    POST_FETCH_NEXT_APPOINTMENTS_FAILURE,

    POST_GET_EMERGENCY_CALL_BY_PATIENT_REQUEST,
    POST_GET_EMERGENCY_CALL_BY_PATIENT_SUCCESS,
    POST_GET_EMERGENCY_CALL_BY_PATIENT_FAILURE,

    POST_GET_CHAT_APPOINTMENT_BY_PATIENT_REQUEST,
    POST_GET_CHAT_APPOINTMENT_BY_PATIENT_SUCCESS,
    POST_GET_CHAT_APPOINTMENT_BY_PATIENT_FAILURE

};
export default actionTypePatient;
